"use strict";
import axios from './axios-on-rails';

// TODO: Make bookmark buttons unclickable when it's loading.

export default class RecommendTileContainer {
  constructor(){
  }

  bookmarkButtonClickHandler(ev) {
    var $btn = $(ev.currentTarget);
    var $aiRecommend = $btn.closest('.ai-recommend');
    var $starBoxes = $aiRecommend.find('.ai-recommend__box-star');

    var memberId = $aiRecommend.attr('data-member-id');
    var jobId = $aiRecommend.attr('data-job-id');

    var isBookmarked = $btn.hasClass('ai-recommend__box-star-yellow');

    if (isBookmarked) {
      this.removeBookmarkMember(memberId);
    } else {
      this.bookmarkMember(memberId, jobId);
    }
  }

  bookmarkMember(memberId, jobId){
    axios({
      method: 'POST',
      url: Routes.member_recommendations_bookmark_member_path(),
      data: {
        job_id: jobId,
        member_id: memberId,
        locale: gon.locale // Necessary for automatic bookmark message.
      }
    }).then(res => {
      var bookmarked = res.data.bookmarked;
      this.changeBookmarkIcon(memberId, bookmarked);
    });
  }

  removeBookmarkMember(memberId){
    axios({
      method: 'DELETE',
      url: Routes.member_recommendations_remove_bookmark_member_path({ member_id: memberId })
    }).then(res => {
      var bookmarked = res.data.bookmarked;
      this.changeBookmarkIcon(memberId, bookmarked);
    });
  }

  changeBookmarkIcon(memberId, bookmarked) {
    var $recommendContainer = $(`.ai-recommend[data-member-id=${memberId}]`);
    var $starBoxes = $recommendContainer.find('.ai-recommend__box-star');

    if (bookmarked) {
      $starBoxes.addClass('ai-recommend__box-star-yellow');
    } else {
      $starBoxes.removeClass('ai-recommend__box-star-yellow');
    }
  }


  initializeTiles() {
    var $recommendBookmark = $('.ai-recommend__box-star');
    $recommendBookmark.on('click', this.bookmarkButtonClickHandler.bind(this));
  }

  loadMemberRecommendationsOneJob(companyProfileId, jobId){
    var params = {
      job_id: jobId,
      company_profile_id: companyProfileId,
      locale: gon.locale,
      format: 'js'
    };

    $.ajax({
      url: Routes.company_profile_job_member_recommendations_path(params),
      cache: false
    }).then(this.initializeTiles.bind(this));
  }

  loadMemberRecommendations(){
    return $.ajax({
      url: Routes.member_recommendations_dashboard_index_path({
        locale: gon.locale,
        format: 'js'
      }),
      cache: false
    }).then(this.initializeTiles.bind(this));
  }

  toggleBookmark() {
    const btn = $('.btn-ai-recommendations');

    if (btn.css('display') === 'none') {
      $('.ai-recommendations').css({ display: 'none' });
      $('.content-wrapper').removeClass('js-ai-recommendations');
      btn.css({ display: 'flex' });
      localStorage.setItem('hideAiRecommend', true);
    } else {
      $('.ai-recommendations').css({ display: 'block' });
      $('.content-wrapper').addClass('js-ai-recommendations');
      btn.css({ display: 'none' });
      localStorage.removeItem('hideAiRecommend');
    }
  }
}
